import { isPublicNavItem } from '../types/PublicNavItem';
export function getPageSlug() {
  const segments = window.location.pathname.split('/').filter(Boolean);
  for (const s of segments) {
    if (isPublicNavItem(s)) return s;
  }
  return undefined;
}